"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Thiana API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfCustomerOutput = instanceOfCustomerOutput;
exports.CustomerOutputFromJSON = CustomerOutputFromJSON;
exports.CustomerOutputFromJSONTyped = CustomerOutputFromJSONTyped;
exports.CustomerOutputToJSON = CustomerOutputToJSON;
var Customer_1 = require("./Customer");
var Metadata_1 = require("./Metadata");
/**
 * Check if a given object implements the CustomerOutput interface.
 */
function instanceOfCustomerOutput(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function CustomerOutputFromJSON(json) {
    return CustomerOutputFromJSONTyped(json, false);
}
function CustomerOutputFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': (json['data'].map(Customer_1.CustomerFromJSON)),
        'metadata': json['metadata'] == null ? undefined : (0, Metadata_1.MetadataFromJSON)(json['metadata']),
    };
}
function CustomerOutputToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'data': (value['data'].map(Customer_1.CustomerToJSON)),
        'metadata': (0, Metadata_1.MetadataToJSON)(value['metadata']),
    };
}
